import React from 'react';
import Header from '@gerenciatd/next.components.header-r';
import Footer from '@gerenciatd/next.components.footer';
import { wrapper } from '@/store';
import { END } from 'redux-saga';
import ErrorScreen, {
  KINDS,
} from '@gerenciatd/next.app-controller.error-screen';

const mainSetup = require('@/config/mainSetup');

const E500 = ({ headerProps, breadcrumbsProps }) => {
  return (
    <>
      <Header {...breadcrumbsProps} {...headerProps} />
      <ErrorScreen kind={KINDS.E500} />
      <Footer />
    </>
  );
};

export const getStaticProps = wrapper.getStaticProps(async ({ store }) => {
  const modules = await Promise.all([
    await import('@gerenciatd/next13.adabyron.misc.get-static-content'),
    await import('@gerenciatd/next13.normalizers.components-header.sections'),
    await import(
      '@gerenciatd/next13.normalizers.components-header.breadcrumbs'
    ),
    await import(
      '@gerenciatd/next.app-controller.reducers-sagas.header-reducer-r'
    ),
  ]);

  const getStaticContent = modules[0].default;
  const getHeaderSections = modules[1].default;
  const getBreadcrumbs = modules[2].default;
  const headerActions = modules[3].actions;

  const { context } = store.getState().main;

  // HEADER USUAL PROPS
  const urlBreadcrumbs = '/static/json/header/breadcrumbs.json';
  const breadcrumbsInfoJson = await getStaticContent({
    resourcePath: urlBreadcrumbs,
    context,
  });
  const url = '/particulares/gaming';
  const breadcrumbsProps = getBreadcrumbs(breadcrumbsInfoJson, url);
  const headerInfoJson = await getStaticContent({
    resourcePath: '/static/json/header/header_plan_r.json',
    context,
  });
  // HEADER REDUX PROPS
  const headerProps = getHeaderSections(headerInfoJson, breadcrumbsProps);
  store.dispatch(headerActions.setupHeaderProps(headerProps));
  store.dispatch(
    headerActions.getFooterInfo({
      pathname: mainSetup.headerFooterPathOnError,
    })
  );
  store.dispatch(END);
  await store.sagaTask.toPromise();

  return {
    props: {
      headerProps,
      breadcrumbsProps,
    },
  };
});

export default E500;
